<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="advanced-search-dialog__dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="advanced-search-dialog__form" @submit.prevent="onSubmit">
        <div class="advanced-search-dialog__form--body">
          <v-toolbar
            flat
            height="76"
            class="advanced-search-dialog__toolbar"
          >
            <v-toolbar-title class="advanced-search-dialog-toolbar-title">Advanced search</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="accent"
              icon
              tile
              @click="closeDialog"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-text-field
              :value="value"
              :key="'value-'+clearFilterTrigger"
              class="bh-input-pill rounded-pill mt-2"
              color="accent"
              height="48px"
              width="200px"
              append-icon="bhi-loupe"
              placeholder="Search in title"
              filled
              clearable
              hide-details
              @input="onInput('query', $event)"
            ></v-text-field>
          </v-container>
          <v-container class="properties pl-6 pr-6">
            <div v-for="item in sequenceProperties" :key="item.name">
              <v-switch
                :ripple="false"
                color="accent"
                v-model="item.enabled"
                :label="item.label"
              ></v-switch>
              <div v-if="item.enabled" class="range">
                {{item.value[0]}}<v-range-slider
                  :min="item.defaultValue[0]"
                  :max="item.defaultValue[1]"
                  v-model="item.value"/>{{item.value[1]}}
              </div>
            </div>
          </v-container>
          <v-container class="advanced-search-dialog__footer d-flex justify-end">
            <v-btn
              rounded
              text
              color="accent"
              elevation="0"
              @click="clearFilters(true)"
            >
              Clear filters
            </v-btn>
            <v-spacer/>
            <v-btn
              rounded
              color="accent"
              elevation="0"
              @click="filter"
            >
              Filter
            </v-btn>
          </v-container>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from '@/helpers/debounce'

const emptyForm = {
}

export default {
  name: 'AdvancedSequenceDefinitionSearchDialog',
  components: {
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    clearFilterTrigger: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialog: false,
      tmpValue: '',
      multipleInputs: [],
      sequenceProperties: [
        { 
          name: 'routinesCount',
          enabled: false,
          label: 'Routines count',
          defaultValue: [0, 10],
          value: [0,10],
          properties: [
            {
              key: 'routinesCountFrom',
              value: null
            },
            {
              key: 'routinesCountTo',
              value: null
            },
          ]
        },
        {
          name: 'days',
          enabled: false,
          label: 'Days count',
          defaultValue: [0, 30],
          value: [0,30],
          properties: [
            {
              key: 'daysFrom',
              value: null
            },
            {
              key: 'daysTo',
              value: null
            },
          ]
        }
      ]
    }
  },
  watch: {
    showDialog: function (val) {
      if (val) {
        this.dialog = true
      } else {
        this.dialog = false
      }
    },
    clearFilterTrigger: function (val) {
      if (val) {
        this.clearFilters(true)
      }
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    closeDialog () {
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
    onInput (key, value) {
      if (key == 'query') this.tmpValue = value
      debounce(() => {
        this.$emit('search-on:input', { key, value })
      },1000, 'SequencesFilters')
    },
    onMultiple (key, value) {
      this.multipleInputs.push({key: key, value: value})
      debounce(() => {
        this.$emit('search-on:multiple', this.multipleInputs)
        this.multipleInputs = []
      },1000, 'SequencesFilters')
    },
    clearSearch() {
      this.tmpValue = ''
      this.$emit('search-on:clear')
    },
    runSearch() {
      if (this.tmpValue)
        this.$emit('search-run', this.tmpValue)
    },
    clearFilters(withSearch = true) {
      this.clearDetails()
      if (withSearch) this.tmpValue = ''
    },
    clearDetails() {
      this.sequenceProperties.forEach(item=>{
        item.value = item.defaultValue
        item.enabled = false
      })
    },
    filter(mode = true) {
      let queryParams = {
        type: null,
        query: null
      }
      if (this.tmpValue) queryParams.query = this.tmpValue
      this.sequenceProperties.forEach(item=>{
        if (item.enabled) {
          queryParams[item.properties[0].key]=item.value[0]
          queryParams[item.properties[1].key]=item.value[1]
        }
      })
      this.$emit('filter', queryParams, mode)
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.advanced-search-dialog {
  &__dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2*$gutter}) !important;
    > .v-card {
      width: 100%;
      height: 100%;
      background-color: $bh-blue--4;
      overflow: auto;
    }
  }
  &__toolbar {
    flex-grow: 0;
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-container {
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-footer {
      padding: 1.5*$gutter;
    }
  }
  &__types {
    display: flex;
    .v-btn {
      background:$bh-white;
      margin-left: $gutter/2;
    }
    &__button-group {
      background: $bh-white;
      border-radius: 50px;
      margin-left: $gutter/2;
      padding: 0 $gutter/2 0 0;
      & > .v-btn:first-child {
        margin-left: 0;
      }
    }
  }
  &__form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;
    .v-btn.active {
      background: $bh-blue !important;
      .v-icon {
        &::before {
          color: $bh-white;
        }
      }
      small {
        color:$bh-white;
      }
    }
    .properties {
      .v-messages {
        display: none;
      }
      .v-label {
        font-size: 12px;
        font-weight: bold;
      }
    }
    .range {
      display: flex;
      align-items: center;
    }
    &--body {
      height: 100%;
      display: flex;
      flex-direction: column;
      ::v-deep .v-toolbar__content {
        padding-left: 1.5*$gutter;
        padding-right: 1.5*$gutter;
      }
    }
  }
}
</style>
